module.exports = __webpack_public_path__ + "img/Feature.c1e6dd1a.jpg";